import React from 'react'
import 'App.scss'
import CssBaseline from '@mui/material/CssBaseline'
import { GlobalStateProvider } from 'state'
import { LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { ThemeProvider, createTheme } from '@mui/material'
import { LoadingDialog } from 'components/dialogs/LoadingDialog'
import 'dayjs/locale/ja'
import utc from 'dayjs/plugin/utc'
import dayjs from 'dayjs'
import { AppRouter } from './AppRouter'

dayjs.extend(utc)

export const App = () => {

  const theme = createTheme({
    typography: {
      fontFamily: '"Helvetica Neue", "Helvetica", "Hiragino Sans", "Hiragino Kaku Gothic ProN", Arial, "Yu Gothic", Meiryo, sans-serif',
    },
    components: {
      MuiTextField: {
        defaultProps: {
          size: 'small',
          variant: 'outlined'
        },
        styleOverrides: {
          root: {
            '& .MuiOutlinedInput-root': {
              backgroundColor: 'white'
            },
          },
        }

      }
    }
  })

  return (
    <div className='app'>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <GlobalStateProvider>
          <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="ja">
            <AppRouter />
            <LoadingDialog />
          </LocalizationProvider>
        </GlobalStateProvider>
      </ThemeProvider>
    </div>
  )
}
